import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TranslocoService} from '@ngneat/transloco';
import {AbstractComponent} from "@components";
import {USER_ROLE, UserDetail} from "@model";
import {AdministratorsService} from "@services";

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent extends AbstractComponent implements OnInit {

  @Input() user: UserDetail | undefined;

  constructor(public translocoService: TranslocoService, private route: ActivatedRoute, private adminService: AdministratorsService) {
    super();
  }

  ngOnInit(): void {
    this.adminService.currentUserDetails.next(this.user);
  }

  isCompetitor() {
    return this.user?.role === USER_ROLE;
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.adminService.currentUserDetails.next(undefined);
  }
}
